module.exports = __webpack_public_path__ + "static/img/project.cfb4cb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project.png
// module id = mUkP
// module chunks = 1